// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2022-2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import { connect } from 'react-redux';

import { Reference } from 'cvat-core-wrapper';
import {
    ReferencesQuery, CombinedState, ActiveInferenceRef, PluginComponent,
} from 'reducers';
import ReferenceItemComponent from 'components/references-page/reference-item';
import { getReferencesAsync, updateReferenceInState as updateReferenceInStateAction, getReferencePreviewAsync } from 'actions/references-actions';
import { cancelInferenceAsyncRef } from 'actions/models-actions';

interface StateToProps {
    deleted: boolean;
    referenceInstance: any;
    activeInference: ActiveInferenceRef | null;
    ribbonPlugins: PluginComponent[];
}

interface DispatchToProps {
    getReferences(query: ReferencesQuery): void;
    updateReferenceInState(reference: Reference): void;
    cancelAutoAnnotation(): void;
}

interface OwnProps {
    idx: number;
    referenceID: number;
}

function mapStateToProps(state: CombinedState, own: OwnProps): StateToProps {
    const reference = state.references.current[own.idx];
    const { deletes } = state.references.activities;
    const id = own.referenceID;

    return {
        deleted: id in deletes ? deletes[id] === true : false,
        referenceInstance: reference,
        activeInference: state.models.inferencesRef[id] || null,
        ribbonPlugins: state.plugins.components.referenceItem.ribbon,
    };
}

function mapDispatchToProps(dispatch: any, own: OwnProps): DispatchToProps {
    return {
        getReferences(query: ReferencesQuery): void {
            dispatch(getReferencesAsync(query));
        },
        cancelAutoAnnotation(): void {
            dispatch(cancelInferenceAsyncRef(own.referenceID));
        },
        updateReferenceInState(reference: Reference): void {
            dispatch(updateReferenceInStateAction(reference));
            dispatch(getReferencePreviewAsync(reference));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceItemComponent);
